export default __webpack_public_path__ + "images/logo_horizontal.d15f82c881d1aa303285ce705b84d8f3.png";